/**
 * Created by vladislav on 31/10/2022
 */

const Customers = function (slot, stock) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;
    this.stock = stock;

    this.customers = [];
    this.customersToRestore = [];

    this.selectedCustomer = undefined;
};

Customers.prototype = Object.create(cleverapps.EventEmitter.prototype);
Customers.prototype.constructor = Customers;

Customers.prototype.addCustomer = function (customer) {
    this.customers.push(customer);
    this.customers.sort((customerA, customerB) => customerA.priority - customerB.priority);

    if (customer.getState() === Customer.STATE_UNINITIALIZED) {
        this.customersToRestore.push(customer);
    }
};

Customers.prototype.restoreCustomers = function () {
    while (this.customersToRestore.length) {
        const customer = this.customersToRestore.shift();
        customer.restore();
        customer.checkRecipe();
    }
};

Customers.prototype.selectCustomer = function (customer) {
    if (this.selectedCustomer && cleverapps.tutorial.isActive() && cleverapps.tutorial.checkConditions({ unit: this.selectedCustomer.unit })) {
        return;
    }

    this.selectedCustomer = customer;

    this.customers.forEach((c) => c.onUpdateState());
    this.trigger("selectedCustomerChanged");

    if (customer) {
        let scrollOptions = {};
        const unitView = customer.unit.onGetView();
        if (unitView) {
            const additionalView = unitView.getAdditionalView("extended_ingredients") || unitView.getAdditionalView("fix_view");
            scrollOptions = additionalView ? unitView.calcScrollOptionsForAdditionalView(additionalView) : {};
        }

        Map2dScroller.currentScroller.scrollToUnit(0.5, customer.unit, scrollOptions);
    }
};

Customers.prototype.isCustomerSelected = function (customer) {
    return this.selectedCustomer === customer;
};

Customers.prototype.removeCustomer = function (customer) {
    let index = this.customers.indexOf(customer);
    if (index !== -1) {
        this.customers.splice(index, 1);
    }

    index = this.customersToRestore.indexOf(customer);
    if (index !== -1) {
        this.customersToRestore.splice(index, 1);
    }
};

Customers.prototype.listActive = function () {
    return this.customers.filter((customer) => customer.getCurrentRecipe());
};

Customers.prototype.onRecipesUpdated = function () {
    this.trigger("onRecipesUpdated");
    this.updateCustomerBubble();
};

Customers.prototype.updateCustomerBubble = function () {
    const pathIndicator = Map2d.currentMap && Map2d.currentMap.pathIndicator;
    if (!pathIndicator || pathIndicator.currentPath) {
        return;
    }

    const active = this.listActive().filter((customer) => !Map2d.currentMap.isOccupiedByFog(customer.unit.x, customer.unit.y));
    const target = active.find((c) => c.unit.code.includes("producer")) || active[0];
    if (target) {
        pathIndicator.showCustomerBubble(target.unit, target.isEnoughIngredientsForRecipe());
    } else if (pathIndicator.bubbleView) {
        pathIndicator.bubbleView.hide(true);
        pathIndicator.bubbleView = undefined;
    }
};

Customers.prototype.updateMarks = function () {
    this.needUpdateMarks = true;

    Map2d.currentMap.counter.trigger(1);
};

Customers.prototype.clearWantsWindow = function () {
    this.customers.forEach((customer) => {
        customer.wantsWindow = undefined;
    });
};

Customers.prototype.process = function () {
    if (cleverapps.focusManager.isFocused() || Map2d.currentMap.dragging) {
        return;
    }

    this.makeNewOrders();

    let wantingWindowCustomer;
    const requiredUnits = {};
    
    this.customers.forEach((customer) => {
        const recipe = customer.getCurrentRecipe();
        if (recipe) {
            const wasReadyForCooking = recipe.wasReadyForCooking;
            recipe.wasReadyForCooking = recipe.isEnoughIngredients();

            if (wasReadyForCooking === false && recipe.wasReadyForCooking) {
                if (!wantingWindowCustomer && Map2d.currentMap.getUnit(customer.unit.x, customer.unit.y)) {
                    wantingWindowCustomer = customer;
                }
            }

            recipe.getIngredients().forEach((ingredient) => {
                if (ingredient.unit) {
                    requiredUnits[Unit.GetKey(ingredient.unit)] = true;
                }
            });
        }
    });

    if (this.needUpdateMarks) {
        this.needUpdateMarks = false;

        Map2d.currentMap.listAvailableUnits((unit) => {
            unit.setCustomerMark(unit.stocked && requiredUnits[Unit.GetKey(unit)]);
        });
    }

    if (this.needUpdateRewards) {
        this.needUpdateRewards = false;

        this.trigger("onRewardsUpdated");
    }

    if (wantingWindowCustomer && !cleverapps.gameModes.silentCustomers) {
        if (wantingWindowCustomer.getViewType() === Customer.VIEW.EXTENDED_CUSTOMER_VIEW) {
            Map2d.currentMap.customers.selectCustomer(wantingWindowCustomer);
        }
    }
};

Customers.prototype.makeNewOrders = function () {
    this.customers.forEach((customer) => {
        if (customer.getState() === Customer.STATE_EMPTY && !customer.getCooldownTimeLeft() && customer.hasSomeRecipes()) {
            customer.order();
        }

        customer.replaceOrderItemsWithCoins();
    });
};

Customers.prototype.findCustomerForHint = function (options) {
    const codes = options.type ? cleverapps.unitsLibrary.listCodesByType(options.type) : [options.code];
    const stage = options.stage;

    const producesType = function (customerCode) {
        const recipes = CustomerRecipes[cleverapps.meta.selectedLocationId()];
        return recipes[customerCode] && recipes[customerCode].some((template) => template.order.some((order) => {
            const orderCodes = order.type ? cleverapps.unitsLibrary.listCodesByType(order.type) : [order.code];
            return orderCodes.some((orderCode) => codes.some((code) => code === orderCode && (stage === undefined || order.stage === stage || (!Families[code].units[stage].unmergeable && stage > order.stage))));
        }));
    };

    const priority = Object.keys(Map2d.currentMap.fogs.config);
    const fakeUnits = Map2d.currentMap.fogs.listFakeUnits({ type: cleverapps.unitsLibrary.getExpeditionUnitType("customer") });

    fakeUnits.sort((a, b) => {
        const fogA = Map2d.currentMap.getFog(a.x, a.y);
        const fogB = Map2d.currentMap.getFog(b.x, b.y);
        return priority.indexOf(fogA && fogA.fogBlock && fogA.fogBlock.id) - priority.indexOf(fogB && fogB.fogBlock && fogB.fogBlock.id);
    });

    for (let i = 0; i < fakeUnits.length; i++) {
        const fakeUnit = fakeUnits[i];
        for (let unitStage = 0; unitStage < Families[fakeUnit.code].units.length; unitStage++) {
            if (producesType(Unit.GetKey({ code: fakeUnit.code, stage: unitStage }))) {
                const real = this.customers.find((customer) => customer.unit.code === fakeUnit.code);
                return real && real.unit || fakeUnit;
            }
        }
    }
};

Customers.prototype.listCustomers = function () {
    return this.customers;
};

Customers.prototype.listCustomersWithRecipe = function () {
    return this.customers.filter((customer) => customer.recipe);
};

Customers.prototype.findCanCook = function () {
    const customers = this.customers;
    for (let i = 0; i < customers.length; i++) {
        if (customers[i].canCook()) {
            return customers[i];
        }
    }

    return undefined;
};

Customers.prototype.findReady = function () {
    const customers = this.customers;
    for (let i = 0; i < customers.length; i++) {
        if (customers[i].getState() === Customer.STATE_READY) {
            return customers[i];
        }
    }

    return undefined;
};

Customers.prototype.requiredIngredientAmount = function (ingredient) {
    ingredient = ingredient.unit || ingredient.ingredient;
    let totalAmount = 0;
    this.customers.forEach((customer) => {
        if (customer.getState() !== Customer.STATE_RECIPE) {
            return;
        }
        customer.recipe.ingredients.forEach((item) => {
            if (
                (item.ingredient && item.ingredient === ingredient.code)
                || (item.unit && item.unit.code === ingredient.code && item.unit.stage === ingredient.stage)
            ) {
                totalAmount += item.amount;
            }
        });
    });
    return totalAmount;
};

Customers.prototype.onUpdateOrder = function (customer) {
    this.trigger("onUpdateOrder", customer);
    this.updateCustomerBubble();
};
